import React, { useState } from 'react';
import { CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { toast } from 'sonner';
import { updateLegalPage } from '../../utils/api';
import RichTextEditor from '../RichTextEditor';

export const AdminLegalPages = ({ legalPages: initial, loadData }) => {
  const [legalPages, setLegalPages] = useState(initial);
  const [activeLegalPage, setActiveLegalPage] = useState('terms_of_use');

  React.useEffect(() => { setLegalPages(initial); }, [initial]);

  const tabs = [
    { id: 'terms_of_use', label: 'Terms of Use' },
    { id: 'privacy_policy', label: 'Privacy Policy' },
    { id: 'copyright_policy', label: 'Copyright & IP Policy' },
  ];

  return (
    <div className="space-y-6" data-testid="legal-pages-cms-tab">
      <div className="bg-white rounded-xl p-6 shadow-sm border border-slate-200">
        <h2 className="text-xl font-bold text-slate-900 mb-4">Legal Pages</h2>
        <div className="flex gap-2 mb-6">
          {tabs.map(tab => (
            <button key={tab.id} onClick={() => setActiveLegalPage(tab.id)}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${activeLegalPage === tab.id ? 'bg-[#8B1818] text-white' : 'bg-slate-100 text-slate-600 hover:bg-slate-200'}`}>{tab.label}</button>
          ))}
        </div>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><Label>Page Title</Label><Input value={legalPages[activeLegalPage]?.title || ''} onChange={(e) => setLegalPages({...legalPages, [activeLegalPage]: {...legalPages[activeLegalPage], title: e.target.value}})} placeholder="Enter page title" /></div>
            <div><Label>Last Updated Date</Label><Input value={legalPages[activeLegalPage]?.last_updated_date || ''} onChange={(e) => setLegalPages({...legalPages, [activeLegalPage]: {...legalPages[activeLegalPage], last_updated_date: e.target.value}})} placeholder="e.g., December 8, 2025" /></div>
          </div>
          <div><Label>Content (HTML)</Label><RichTextEditor value={legalPages[activeLegalPage]?.content || ''} onChange={(val) => setLegalPages({...legalPages, [activeLegalPage]: {...legalPages[activeLegalPage], content: val}})} placeholder="Enter legal page content..." /></div>
          <Button className="bg-[#8B1818] text-white" onClick={async () => {
            try { await updateLegalPage(activeLegalPage, legalPages[activeLegalPage]); toast.success('Legal page saved'); loadData(); } catch (err) { toast.error('Failed'); }
          }}><CheckCircle className="mr-2 h-4 w-4" />Save {tabs.find(t => t.id === activeLegalPage)?.label}</Button>
        </div>
      </div>
    </div>
  );
};
